import { FC } from "react";

type CalendarPickerIconProps = {
  size?: number;
  fill?: string;
  className?: string;
};

const CalendarPickerIcon: FC<CalendarPickerIconProps> = ({
  size = 24,
  fill = "#535353",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M18.3111 5.6H17.4667V4H15.7778V5.6H8.22222V4H6.53333V5.6H5.68889C4.75156 5.6 4.00844 6.32 4.00844 7.2L4 18.4C4 19.28 4.75156 20 5.68889 20H18.3111C19.24 20 20 19.28 20 18.4V7.2C20 6.32 19.24 5.6 18.3111 5.6ZM18.3111 18.4H5.68889V9.6H18.3111V18.4ZM7.37778 11.2H11.6V15.2H7.37778V11.2Z"
        fill={fill}
        style={{ fill, fillOpacity: 1 }}
      />
    </svg>
  );
};

export default CalendarPickerIcon;
